import { defineComponent as _defineComponent } from 'vue'
import { reactive, watch } from "vue";

// Props
type PropTypes = {
  value?: boolean;
  active_background_color?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'toggle',
  props: {
    value: { type: Boolean, default: false },
    active_background_color: { default: "hsl(208, 59%, 44%)" }
  },
  setup(__props: any, { expose, emit }: { emit: ({
  input: [value: boolean];
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, active_background_color: string };



// Emits


// Reactive state object
const state = reactive({
  is_on: false,
});

// Watch for prop changes (equivalent to @Watch('value'))
watch(
  () => props.value,
  (new_value: boolean, old_value: boolean) => {
    state.is_on = new_value;
  },
);

// Methods
const toggle = () => {
  state.is_on = !state.is_on;
  emit("input", state.is_on);
};

// Initialize (equivalent to created lifecycle)
state.is_on = props.value;

// Expose state for external access (tests, parent components)
expose({
  state,
});

return { __sfc: true,props, emit, state, toggle }
}

})